<template><!-- svgo-optimised -->
<svg class="icon icon__check-alt" viewBox="0 0 11 9" xmlns="http://www.w3.org/2000/svg"><path d="M10 1 3.5 7.5 1 5" stroke="#fff"/></svg></template>